import { render, staticRenderFns } from "./HomeNewsDistributeChart.vue?vue&type=template&id=f144c37a&scoped=true"
import script from "./HomeNewsDistributeChart.vue?vue&type=script&lang=js"
export * from "./HomeNewsDistributeChart.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsDistributeChart.vue?vue&type=style&index=0&id=f144c37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f144c37a",
  null
  
)

export default component.exports